<template>
  <div class="contentBox">
    <navBox :id="navId"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType" style="height:calc( 100% - 100px )">
        <div class="backBox">
          <button class="btn btn-back" @click="closeSub">返回</button>
        </div>
        <div class="write-txt">
          <p class="write-title">选择资源库：<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.lid" placeholder="请选择">
              <el-option
                v-for="item in libList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">资源包名称：<span>*</span></p>
          <div class="write-text">
            <textarea placeholder="" v-model="addObj.title"></textarea>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">设备类型：<span>*</span></p>
          <div class="write-text">
            <el-radio-group v-model="addObj.type" style="display: inline-block;vertical-align: middle;">
              <el-radio label="1">苹果</el-radio>
              <el-radio label="2">安卓</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">会员有效期：<span>*</span></p>
          <div class="write-text">
            <input type="number" class="num" v-model="addObj.vip_time" @change="$forceUpdate()" style="display: inline-block;vertical-align: middle;">
            <el-radio-group v-model="vip_date" style="display: inline-block;vertical-align: middle;">
              <el-radio label="d">天</el-radio>
              <el-radio label="m">月</el-radio>
              <el-radio label="y">年</el-radio>
            </el-radio-group>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">价格：<span>*</span></p>
          <div class="write-text">
            <input type="number" v-model="addObj.price">
            <!-- <textarea placeholder="" v-model="addObj.price"></textarea> -->
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">单价：</p>
          <div class="write-text">
            <input type="text" v-model="addObj.unit_price_value">
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">角标：</p>
          <div class="write-text">
            <input type="number" v-model="addObj.act_str">
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">模式：<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.model" placeholder="请选择">
              <el-option label="会员页" value="1"></el-option>
              <!-- <el-option label="收银台" value="2"></el-option> -->
            </el-select>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">排序：<span>*</span></p>
          <div class="write-text">
            <input type="number" v-model="addObj.sort">
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">是否默认选中：<span>*</span></p>
          <div class="write-text">
            <el-radio-group v-model="addObj.is_selected">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </div>
        </div>

        <div class="write-txt" v-if="addObj.type==1">
          <p class="write-title">连续订阅：<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.bind_id" placeholder="请选择">
              <el-option
                v-for="item in vipList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>

      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <p>添加资源包</p>
          </div>
          <div class="searchBox clear">
            <div class="search-item name">
              <p>资源包名称：</p>
              <input type="text" placeholder="请输入要搜索的会员名称" v-model="obj.title">
            </div>
            <div class="search-item">
              <p>排序：</p>
              <el-select v-model="obj.sort" placeholder="请选择">
                <el-option key="1" label="正序" value="asc"></el-option>
                <el-option key="2" label="倒序" value="desc"></el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p>发布状态：</p>
              <el-select v-model="obj.publish_status" placeholder="请选择">
                <el-option key="3" label="全部" value="9"></el-option>
                <el-option key="1" label="否" value="0"></el-option>
                <el-option key="2" label="是" value="1"></el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p>创建时间：</p>
              <el-select v-model="obj.create_time" placeholder="请选择">
                <el-option key="1" label="正序" value="asc"></el-option>
                <el-option key="2" label="倒序" value="desc"></el-option>
              </el-select>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <p class="list-title">资源包付费列表</p>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.id">{{item.id}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.type==1?'苹果':'安卓'">{{item.type==1?'苹果':'安卓'}}</p>
              <p :title="item.price">{{item.price}}</p>
              <p :title="item.vip_time">{{item.vip_time}}</p>
              <p >
                <el-switch
                  @change="switchChange(item)"
                  v-model="item.publish_status"
                  active-color="#00C7A3"
                  inactive-color="#CBCBCB">
                </el-switch>
              </p>
              <p :title="item.sort">{{item.sort}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p class="btnList">
                <button title="编辑" class="btn btn-revise" @click="buildSub(item)">编辑</button>
                <button title="删除" style="color: #FF1919;" class="btn btn-remove" @click="removeShow(item)">删除</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="removeHide">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getResourcePackList,saveResourcePack ,getResourcePackDetail,delResourcePack ,updateResourcePackStatus,getResourceIphoneList ,getAllPackageList} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "resource",
  data() {
    return {
      navId:'5',
      titleList:[
        {id:1,title:'ID'},
        {id:2,title:'资源包名称'},
        {id:3,title:'设备类型'},
        {id:4,title:'价格'},
        {id:5,title:'有效期'},
        {id:6,title:'状态'},
        {id:7,title:'排序'},
        {id:8,title:'创建时间'},
        {id:9,title:'操作'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        type:'1',
        model:'1',
        title:'',
        price:'',
        unit_price_value:'',
        vip_time:'',
        sort:'',
        is_selected:'1',
        act_str:''
      },
      vip_date:'d',
      totalPage:0,
      removeID:'',
      url:'',
      vipList:[],
      libList:[]
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj = {
        page:1,
        rows:10,
      };
      this.addObj = {
        type:'1',
        model:'1',
        title:'',
        price:'',
        unit_price_value:'',
        vip_time:'',
        sort:'',
        is_selected:'1',
        act_str:''
      };
      this.vip_date = 'd'
      this.dataList = [];
      this.getList();
    },

    async getVipList(){
      var that = this;
      try {
        const response = await getResourceIphoneList(this.token);
        if(response.code == 200){
          that.vipList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async getlibList(){
      var that = this;
      try {
        const response = await getAllPackageList(this.token);
        if(response.code == 200){
          that.libList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async getList(){
      var that = this;
      try {
        const response = await getResourcePackList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.publish_status==0){
              item.publish_status=false
            } else {
              item.publish_status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
      this.getlibList();
      this.getVipList();
    },

    async buildSub(e){
      var that = this;
      this.getlibList();
      this.getVipList();
      try {
        const response = await getResourcePackDetail({id:e.id},this.token);
        if(response.code == 200){
          response.data.type = JSON.stringify(response.data.type);
          response.data.is_selected = JSON.stringify(response.data.is_selected);
          response.data.model = JSON.stringify(response.data.model);
          response.data.sort = JSON.stringify(response.data.sort);
          that.vip_date = JSON.parse(JSON.stringify(response.data.vip_time.split('')[response.data.vip_time.split('').length-1]));
          that.addObj = JSON.parse(JSON.stringify(response.data));
          var time = '';
          response.data.vip_time.split('').forEach(function(item,index){
            if(index == (response.data.vip_time.split('').length-1)){

            } else {
              time = time + item
            }
          })
          that.addObj.vip_time = time;
          that.addType = 'edit';
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delResourcePack({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.removeType = false;
          that.removeID = '';
          that.getList();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeHide(){
      var that = this;
      that.removeType = false;
      that.removeID = '';
    },

    async saveSub(){
      var that = this;
      if(this.addObj.lid == ''){
        that.$message('请选择资源库！');
        return false;
      }
      if(this.addObj.title == ''){
        that.$message('请输入资源包名称！');
        return false;
      }
      if(this.addObj.vip_time == ''){
        that.$message('请输入有效期！');
        return false;
      }
      if(this.addObj.price == ''){
        that.$message('请填写价格！');
        return false;
      }
      if(this.addObj.sort == ''){
        that.$message('请填写排序！');
        return false;
      }
      this.addObj.vip_time = this.addObj.vip_time + this.vip_date;
      if(this.addObj.type == 1){
        if(!this.addObj.bind_id){
          this.addObj.bind_id = -1
        }
      }
      try {
        const response = await saveResourcePack(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async switchChange(e){
      var that = this;
      var obj = {
        id:e.id,
        publish_status:e.publish_status==false?0:1,
      };
      try {
        const response = await updateResourcePackStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
          that.getList();      
        } else {
          that.$message(response.msg);
          e.status = !e.status;
        }
      } catch (error) {
        that.$message(error);
        e.status = !e.status;
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {
        type:'1',
        model:'1',
        title:'',
        price:'',
        unit_price_value:'',
        vip_time:'',
        sort:'',
        is_selected:'1',
        act_str:''
      };
      this.vip_date = 'd';
    },
    
  }

  
};
</script>
<style scoped>
  .search-item.name input{
    width: 240px;
  }

  .search-item>>> input{
    width: 147px;
    border: solid 1px #333333;
  }

  .el-select-dropdown__item.selected{
    color: #333333;
  }

  .el-select-dropdown__item.hover{
    background-color: #00C7A3;
    color: #fff;
  }

  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 9 );
  }

  .dataList .listItem p.btnList{
    font-size: 0;
  }

  .btnList .btn{
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    color: #333333;
    margin: 0 0 7px 0;
    width: 50%;
    text-align: left;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }
  
  .MobelBox input{
    height: 45px;
    width: 200px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .write-btnBox .btn{
    width: 145px;
    height: 51px;
    line-height: 51px;
    border-radius: 8px;
    color: #fff;
    background-color: #00C7A3;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 80px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.write-txt>>> .el-radio__inner{
  width: 20px;
  height: 20px;
}

.write-txt>>> .el-radio__inner::after{
  width: 10px;
  height: 10px;
}

.reviewBox .write-text input,
.write-txt>>> .el-radio-group{
  display: inline-block;
  vertical-align: middle;
}

.content>>> .el-radio__input.is-checked .el-radio__inner{
  background-color: #00C7A3;
  border-color: #00C7A3;
}
.content>>> .el-radio__input.is-checked+.el-radio__label{
  color: #00C7A3;
}
.content>>> .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #00C7A3;
}
</style>



// WEBPACK FOOTER //
// src/pack/index.vue